module.exports = __webpack_public_path__ + "investor-education-static-manager/img/404.9f74df0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/404.jpg
// module id = H4CK
// module chunks = 42